// components/Tables/RecordTable.tsx
import { useRecordTable } from '../../../hooks/useRecordTable';
import TableHeader from '../base/TableHeader';
import TableBody from '../base/TableBody';
import TableFooter from '../base/TableFooter';
import TablePagination from '../base/TablePagination';
import clsx from 'clsx'; // Asegúrate de tener clsx instalado
import { CustomColumn } from '../../../types/customColumn';


interface RecordTableProps<T extends object> {
  columns: CustomColumn<T>[];
  data: T[];
  actions?: any;
  pageSize?: number;
  noDataMessage?: string;
  showFooter?: boolean;
  showFilters?: boolean;
  tableHeaderContent?: React.ReactNode; // izquierda
  tableHeaderActions?: React.ReactNode; // ✨ derecha (nueva)
  maxWidth?: string;
}

const RecordTable = <T extends object>({
  columns,
  data,
  actions,
  pageSize = 10,
  noDataMessage = 'No hay registros disponibles.',
  showFooter = true,
  showFilters = true,
  tableHeaderContent,
  tableHeaderActions,
  maxWidth = 'max-w-6xl',
}: RecordTableProps<T>) => {
  const table = useRecordTable<T>({ columns, data, pageSize });

  return (
    <div
      className={clsx(
        'mt-6 w-full rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark',
        maxWidth
      )}
    >
      <div className="mb-4 px-4 pt-4">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
          {/* Título */}
          <div className="text-left">{tableHeaderContent}</div>

          {/* Botones de acción */}
          <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row">
            {tableHeaderActions}
          </div>
        </div>
      </div>

      {/* Tabla */}
      <section className="data-table-common data-table-two border-b border-t border-stroke bg-white py-4 shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="w-full overflow-x-auto p-2">
          <table
            {...table.getTableProps()}
            className="datatable-table w-full min-w-[700px] table-auto border-collapse break-words md:table-fixed md:overflow-auto"
          >
            <TableHeader
              table={table}
              showFilters={showFilters}
              actions={actions}
            />
            <TableBody
              table={table}
              actions={actions}
              noDataMessage={noDataMessage}
            />
            {showFooter && <TableFooter table={table} actions={actions} />}
          </table>
        </div>

        {/* Paginación */}
        <TablePagination table={table} />
      </section>
    </div>
  );
};

export default RecordTable;
